module.exports = __webpack_public_path__ + "img/20180815_145911_035.682e6d2f.jpg";